<template>
    <div class="locations-ctas">
      <h2 class="space-section__h2 mb-4 text-left" style="width: 100%">{{titleLabel}}</h2>
      <p class="__p">{{findSpaceLabel}}</p>
      <p class="mb-4">{{addressLabel}} <br/> Tijuana, B.C.</p>
      <div class="cta-buttons">
        <a href="https://www.google.com/maps/place/Spacebar+Coworking+Spaces/@32.5159187,-117.0003841,19.9z/data=!4m6!3m5!1s0x80d949c01f733683:0x5984fc85c1be2247!8m2!3d32.5159917!4d-117.0002622!16s%2Fg%2F11lgrm6bps?entry=ttu" target="_blank" class="btn d-flex justify-content-between">
          <span class="ps-2">{{goWithLabel}} Google Maps</span>
          <img src="https://spacebar.mints.cloud/public-assets/google-maps-icon" style="max-width: 26px;" alt="" class="me-2">
        </a>
        <a href="https://waze.com/ul?q=Prolongación Paseo de los Héroes, Calz. Escolar 5A, Agua Caliente, C.P 22014 Tijuana, B.C" target="_blank" class="btn d-flex justify-content-between">
          <span class="ps-2">{{goWithLabel}} Waze</span>
          <img src="https://spacebar.mints.cloud/public-assets/waze-icon" style="max-width: 26px;" alt="" class="me-2">
        </a>
        <a href="http://maps.apple.com/?q=Prolongación Paseo de los Héroes, Calz. Escolar 5A, Agua Caliente, C.P 22014 Tijuana, B.C" target="_blank" class="btn d-flex justify-content-between">
          <span class="ps-2">{{goWithLabel}} Apple Maps</span>
          <img src="https://spacebar.mints.cloud/public-assets/apple-maps-icon" style="max-width: 26px;" alt="" class="me-2">
        </a>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LocationsCTAs',
      inject: ['locale'],
      computed:{
        titleLabel(){
            return locale === 'es' ? 'Ubicación' : 'Location'
        },
          findSpaceLabel(){
            return locale === 'es' ? 'Encuentra tu espacio en' : 'Find your space at'
          },
          addressLabel(){
            return locale === 'es' ? 'Prolongación Paseo de los Héroes, Calz. Escolar 5A, Agua Caliente, C.P 22014' : `PROL PASEO DE LOS HEROES, Calz. Escolar 5A, Agua Caliente, 22014`
          },
          goWithLabel(){
            return locale == 'es' ? 'Ir con' : 'Go with '
          }
      }
  };

  </script>

  <style lang="scss" scoped>
  .btn{
    span{
      font-weight: 500 !important;
    }
  }
  .locations-ctas {
    border-radius: 8px;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    @media (max-width:768px) {
      max-width: 100%;
      text-align: center;
      h2{
        text-align: center !important;
        &::after{
          left: 50% !important;
          transform: translate(-50%, 0);
        }
      }
      .__p{
        text-align: center !important;
        width: 100%;
      }
    }
    .__p{
        font-weight: 700;
        font-size: 14px;
        color: rgb(172, 172, 172);
    }
    .space-section__h2{
        text-align: left;
        padding-inline: 0;
        &::after{
            left: 0;
        }
    }
    max-width: 80%;
  }


  
  .locations-ctas h2 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  
  .locations-ctas p {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }
  
  .cta-buttons{
    display: flex;
    flex-direction: column;
    gap: 10px;
        a {
        display: flex;
        justify-content: start;
        text-decoration: none;
        padding: 8px 16px;
        margin-bottom: 0.5rem;
        font-size: 15px;
        color: black;
        border-radius: 25px;
        border: 2px solid #74e9de;
        background-color: transparent;
        max-width: 250px;
        min-width: 250px;
        align-items: center;
    }
    @media (max-width:768px) {
      align-items: center !important;
      width: 100% !important;
      max-width: 100% !important;
      a{
        font-size: 13px !important;
        padding: 6px 16px;
        display: flex;
        align-items: center;
      }
    }
  } 

</style>
